import SendAsPage from './send-as-page';

export default function SendAsGridPage() {
  return <SendAsPage />;
}
